import React from 'react';

interface InkBarProps {
	left?: number;
	width?: number;
}

export const InkBar: React.FC<InkBarProps> = ({ left = 0, width = 0 }) => (
	<div className="RRT__inkbar-wrapper">
		<div className="RRT__inkbar" style={{ left, width }} />
	</div>
);

export default InkBar;
